import { render } from "./detialsBranch.vue?vue&type=template&id=5b966f17&scoped=true"
import script from "./detialsBranch.vue?vue&type=script&lang=js"
export * from "./detialsBranch.vue?vue&type=script&lang=js"

import "./detialsBranch.vue?vue&type=style&index=0&id=5b966f17&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b966f17"]])

export default __exports__